const points = [
	{ title: 'Product Engineering', text: 'Mobile apps, websites, and secure data platforms.' },
	{ title: 'Execution Quality', text: 'Performance-first builds with maintainable architecture.' },
	{ title: 'Industry Focus', text: 'Digital transformation for healthcare-oriented operations.' },
];

const contact = [
	{ label: 'Address', value: 'Sulochana Apartments, Income Tax Lane, Pune - 411004' },
	{ label: 'Email', value: 'admin@viance.co.in' },
	{ label: 'Phone', value: '9823272353' },
];

function About() {
	return (
		<section id="about" className="rounded-3xl bg-white px-6 py-14 shadow-sm ring-1 ring-slate-200 sm:px-8 sm:py-16 lg:px-12 lg:py-20">
			<div className="mx-auto grid max-w-6xl gap-8 lg:grid-cols-[1.25fr_0.75fr] lg:items-start">
				<div>
					<p className="text-xs font-semibold uppercase tracking-[0.18em] text-cyan-700">About Company</p>
					<h2 className="mt-2 text-3xl font-bold text-slate-900 sm:text-4xl">About Viance Healthcare Systems</h2>
					<p className="mt-4 max-w-3xl text-base leading-relaxed text-slate-600 sm:text-lg">
						VIANCE HEALTHCARE SYSTEMS PRIVATE LIMITED is a product engineering company helping
						organizations build and scale digital platforms. We combine practical architecture,
						modern UI development, and dependable data systems to deliver business-ready software.
					</p>

					<div className="mt-7 grid gap-3 sm:grid-cols-3">
						{points.map((point) => (
							<div key={point.title} className="rounded-xl border border-slate-200 bg-slate-50 p-4">
								<p className="text-sm font-semibold text-slate-900">{point.title}</p>
								<p className="mt-1 text-sm text-slate-600">{point.text}</p>
							</div>
						))}
					</div>
				</div>

				<div className="rounded-2xl border border-cyan-100 bg-cyan-50/40 p-5">
					<p className="text-sm font-semibold uppercase tracking-wide text-cyan-700">Contact Details</p>
					<div className="mt-4 space-y-3">
						{contact.map((item) => (
							<div key={item.label} className="rounded-lg border border-cyan-100 bg-white p-3">
								<p className="text-xs font-semibold uppercase tracking-wide text-cyan-700">{item.label}</p>
								<p className="mt-1 text-sm text-slate-700">{item.value}</p>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}

export default About;
